import { render, staticRenderFns } from "./ShowButton.vue?vue&type=template&id=6b63b8d6"
import script from "./ShowButton.vue?vue&type=script&lang=js"
export * from "./ShowButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports